export const employeeNotificationKeys = {
  all: ['employee-notifications'] as const,
  mine: (employeeId: number) => [...employeeNotificationKeys.all, 'mine', employeeId] as const,
};
